import { AutoLinkNode, LinkNode } from '@lexical/link';

export const $addLinkNodeConfig = (nodes) => {
  nodes.push(AutoLinkNode);
  nodes.push(LinkNode);
};

export default LinkNode;
